export enum LOAN_INSURANCE_BATCH_STATUS {
  NEW = 'NEW',
  IN_PROCESS = 'IN_PROCESS',
  SUBMIT_FOR_ZURICH = 'SUBMIT_FOR_ZURICH',
  REQUEST_SUBMIT_FOR_ZURICH = 'REQUEST_SUBMIT_FOR_ZURICH',
  PENDING_FROM_ZURICH = 'PENDING_FROM_ZURICH',
  UPLOAD_ZURICH_REPORT_SUCCESSFUL = 'UPLOAD_ZURICH_REPORT_SUCCESSFUL',
  COMPLETED = 'COMPLETED',
}
